export default "__VITE_ASSET__D82nL6Ee__"